import { Component, inject } from "@angular/core";
import { ROUTES } from "../../constants/routes";
import { RouterLink } from "@angular/router";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SITE } from "../../constants/site";
import { ICONS } from "../../constants/icons";
import { FOOTER_TRUST } from "../../constants/compliance";

@Component({
  selector: "app-footer",
  imports: [RouterLink],
  templateUrl: "./footer.html",
  styleUrl: "./footer.scss"
})
export class Footer {
  readonly routes = ROUTES;
  readonly year = new Date().getFullYear();
  readonly site = SITE;
  readonly trustBadges = FOOTER_TRUST;
  private readonly sanitizer = inject(DomSanitizer);

  iconFor(name: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(ICONS[name] ?? "");
  }

  readonly states = [
    "California", "Texas", "Florida", "New York", "Illinois", "Pennsylvania",
    "Ohio", "Georgia", "North Carolina", "Michigan", "New Jersey", "Arizona",
    "Washington", "Massachusetts", "Virginia", "Tennessee"
  ];
}
